// LocalStorage keys.
export const USER_DOWNLOADED_SOMETHING = "USER_DOWNLOADED_SOMETHING";
export const EXPAND_DROP_TARGET = 'EXPAND_DROP_TARGET';


// Other constants.
export const DOCUMENT_MIME_TYPES = 'application/pdf,image/png,image/jpeg';
